import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get values() {
    return {
      name: String,
      properties: Object,
      gaCategory: String,
      gaAction: String,
      ga4Event: String,
    }
  }

  connect() {
    // Tracking for basic events
    if (this.hasNameValue) {
      App.analytics.track(this.nameValue, this.propertiesValue)
    }

    // Tracking For Google Analytics 4
    if (this.hasGa4EventValue) {
      App.analytics.ga4_track(this.ga4EventValue)
    }

    // Tracking for Google Analytics
    if (this.hasGaCategoryValue && this.hasGaActionValue) {
      App.analytics.ga_track(this.gaCategoryValue, this.gaActionValue)
    }

    this.element.remove()
  }
}
